import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function BrandsSection() {
  const brands = [
    {
      name: 'Speedy DMV Services™',
      tagline: 'Fast. Friendly. Reliable.',
      description: 'Fast, friendly, and reliable DMV services in the heart of Las Vegas. Our team of experts handles every step so you don\'t have to.',
      features: ['Quick Processing', 'Expert Staff', 'Multiple Locations', 'Same-Day Service'],
      image: 'https://public.readdy.ai/ai/img_res/ce4d3cdd32b44efd41669b3bc3b50470.jpg',
      accent: 'from-amber-500 to-yellow-400',
      iconColor: 'text-amber-400',
      borderColor: 'border-amber-500/30',
      bgAccent: 'bg-amber-500/8',
    },
    {
      name: 'DMV-Xpress Services™',
      tagline: 'Streamlined. Efficient. Trusted.',
      description: 'Streamlined document and vehicle services with unbeatable customer care. Express processing for clients who value their time.',
      features: ['Express Processing', 'Document Prep', 'VIN Inspections', 'Title Services'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20document%20processing%20center%20with%20dark%20sophisticated%20interior%2C%20organized%20filing%20systems%2C%20staff%20reviewing%20vehicle%20paperwork%20and%20titles%2C%20efficient%20modern%20office%20with%20warm%20golden%20lighting%2C%20premium%20customer%20service%20desk&width=600&height=350&seq=dmv-xpress-dark-001&orientation=landscape',
      accent: 'from-yellow-400 to-amber-300',
      iconColor: 'text-yellow-400',
      borderColor: 'border-yellow-500/30',
      bgAccent: 'bg-yellow-500/8',
    },
  ];

  return (
    <section id="brands" className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/25 mb-5">
            <i className="ri-building-2-line text-amber-400 mr-2 text-sm"></i>
            <span className="text-xs font-semibold text-amber-400 tracking-widest uppercase">Our Companies</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            Meet Our{' '}
            <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
              Brands
            </span>
          </h2>
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-12 bg-amber-500/50"></div>
            <i className="ri-star-fill text-amber-500 text-xs"></i>
            <div className="h-px w-12 bg-amber-500/50"></div>
          </div>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Two trusted brands serving the Las Vegas community with excellence and dedication
          </p>
        </div>

        {/* Brand Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {brands.map((brand, index) => (
            <div
              key={index}
              className={`group bg-gray-900 border ${brand.borderColor} hover:border-amber-400/50 rounded-2xl overflow-hidden transition-all duration-400`}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={brand.image}
                  alt={brand.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/30 to-transparent"></div>
                <div className={`absolute top-4 left-4 px-3 py-1 rounded-full bg-gradient-to-r ${brand.accent} text-gray-900 text-xs font-bold tracking-wide`}>
                  {brand.tagline}
                </div>
              </div>

              {/* Content */}
              <div className="p-7">
                <h3 className={`text-2xl font-bold mb-3 bg-gradient-to-r ${brand.accent} bg-clip-text text-transparent`}>
                  {brand.name}
                </h3>
                <p className="text-gray-400 mb-6 leading-relaxed text-sm">
                  {brand.description}
                </p>

                {/* Features */}
                <div className="mb-6">
                  <h4 className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-3">Key Services</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {brand.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center text-sm text-gray-300">
                        <div className="w-4 h-4 flex items-center justify-center mr-2 shrink-0">
                          <i className={`ri-check-line ${brand.iconColor} text-sm`}></i>
                        </div>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex gap-3">
                  <Button variant="primary" size="sm">
                    <i className="ri-external-link-line mr-1.5"></i>
                    Visit Website
                  </Button>
                  <Link to="/brands">
                    <Button variant="outline" size="sm">
                      Learn More
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <Link to="/brands">
            <button className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 font-medium text-sm border-b border-amber-500/40 hover:border-amber-400 pb-0.5 transition-all duration-300">
              <i className="ri-building-2-line"></i>
              View full brand details
              <i className="ri-arrow-right-line"></i>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
